var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 18.9583C5.6335 18.9583 2.0835 15.4083 2.0835 11.0417C2.0835 6.675 5.6335 3.125 10.0002 3.125C14.3668 3.125 17.9168 6.675 17.9168 11.0417C17.9168 15.4083 14.3668 18.9583 10.0002 18.9583ZM10.0002 4.375C6.32516 4.375 3.3335 7.36667 3.3335 11.0417C3.3335 14.7167 6.32516 17.7083 10.0002 17.7083C13.6752 17.7083 16.6668 14.7167 16.6668 11.0417C16.6668 7.36667 13.6752 4.375 10.0002 4.375Z",
    fill: "#070519"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 5.41675C8.97059 5.41675 7.96235 5.71017 7.09356 6.26264C6.22478 6.81511 5.53144 7.60374 5.09478 8.53613C4.65813 9.46851 4.49624 10.506 4.6281 11.5271C4.75996 12.5482 5.18009 13.5106 5.83928 14.3015C6.49846 15.0923 7.36939 15.679 8.35002 15.9926C9.33065 16.3063 10.3804 16.3339 11.3762 16.0724C12.372 15.8109 13.2726 15.2709 13.9725 14.5159C14.6725 13.7608 15.1427 12.822 15.3282 11.8092L10.0002 10.8334V5.41675Z",
    fill: "#6374FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2.29175H7.5C7.15833 2.29175 6.875 2.00841 6.875 1.66675C6.875 1.32508 7.15833 1.04175 7.5 1.04175H12.5C12.8417 1.04175 13.125 1.32508 13.125 1.66675C13.125 2.00841 12.8417 2.29175 12.5 2.29175Z",
    fill: "#070519"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.1f7fa81560ac83ed3f7b182f4037cda6.svg";
export { ForwardRef as ReactComponent };